import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject, Injector } from '@angular/core';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { TokenRefreshService } from 'src/services/token-refresh.service';
import { EWatchedResponseCodes } from 'src/util/constants';

/**
 * HTTP interceptor for 401 Unauthorized errors
 *  - 401 received (can be multiple)
 *  - generates new access token with refresh endpoint
 *  - tokenData in store updated
 *  - all requests refetched
 *
 * All coordination state lives in TokenRefreshService: a functional interceptor is
 * re-invoked per request, so it cannot hold the in-flight refresh state itself.
 */
const AUTH_ENDPOINTS = [
  '/security/loginBCAS-web',
  '/security/loginBCAS-mobile',
  '/security/refresh',
  '/security/refresh-web',
  '/security/logout',
];

const isAuthEndpoint = (url: string): boolean => AUTH_ENDPOINTS.some(e => url.includes(e));

export const refreshInterceptor: HttpInterceptorFn = (req, next) => {
  // Skip interceptor for auth endpoints to avoid infinite loops
  if (isAuthEndpoint(req.url)) {
    return next(req);
  }

  const injector = inject(Injector);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === EWatchedResponseCodes.UNAUTHORIZED) {
        return injector.get(TokenRefreshService).handle401(req, next);
      }
      return throwError(() => error);
    })
  );
};
